
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.509 14.006h-.794l-.276-.274a6.472 6.472 0 001.569-4.228 6.5 6.5 0 00-6.5-6.5 6.5 6.5 0 00-6.5 6.5 6.5 6.5 0 006.5 6.5 6.474 6.474 0 004.227-1.567l.276.274v.792l5 4.994 1.489-1.489-4.991-5zm-6.005 0a4.5 4.5 0 01-4.5-4.5 4.5 4.5 0 014.5-4.5 4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      